import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueApexCharts from 'vue-apexcharts';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheckCircle, faCircle, faCheck, faChevronRight, faChevronUp, faChevronDown,
} from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Tracker from '@/services/tracker';
import App from './App.vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './styles/main.scss';
import router from './router';
import store from './store';
import 'shepherd.js/dist/css/shepherd.css';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

library.add(faCheckCircle, faCircle, faFacebookF, faTwitter, faWhatsapp, faCheck);
library.add(faChevronRight, faChevronUp, faChevronDown);
Vue.component('font-awesome-icon', FontAwesomeIcon);


Vue.mixin({
  methods: {
    track(label, action) {
      Tracker.track(label, action);
    },
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
